import React, {useEffect} from 'react';
import {MainList, PartialMainList, TeacherMainList, NationalDashboardList, PartnerDashboardList, SchoolDashboardList, NetworkDashboardList, ClassDashboardList, IndividualDashboardList} from './components';
import { USER_ACCESS_LEVEL } from '../../utils/constants';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';


import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExistToAppIcon from '@material-ui/icons/ExitToApp';

import {Copyright} from '../../components'
import { withRouter } from "react-router";
import { logoutUser, switchWorkspaceService } from '../../services/auth.service';
import OrgPickerDialog from '../../components/OrgPickerDialog/OrgPickerDialog.comp';
import { useAuth } from "../../context/auth";
import {LOCAL_STORAGE_KEYS} from "../../utils/constants";
import Avatar from "@material-ui/core/Avatar";
import {AccountCircle} from "@material-ui/icons";
import BrandingLogo from "../../components/BrandingLogo/BrandingLogo.comp";
import { clearAllBrandingCaches } from '../../context/branding/branding.context';
import { useTutorial, TUTORIAL_SESSION_DISMISS_KEY } from '../../components/TutorialSystem';
import { useColorMode } from '../../context/colorMode/colorMode.context';
import { isClientWorkspace } from '../../utils/capabilities';
const drawerWidth = 275;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        backgroundColor: 'var(--brand-bg, #F4EEEE)',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'var(--brand-bg, #F4EEEE)',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    content: {
        backgroundColor: 'var(--brand-bg, #FFFBF7)',
        flexGrow: 1,
        minWidth: 0,
        paddingTop: 0,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 64,
        },
    },
    menuButton: {
        marginRight: 36,
        color: theme.palette.primary.main,
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    drawerPaper: {
        width: '300px',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        borderRadius: 0,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        background: 'var(--brand-surface, #ffffff)',
        color: 'var(--brand-text-muted, #A5A5A5)',
        boxShadow: 'none',
        border: 'none',
        [theme.breakpoints.down('lg')]: {
            overflowX: 'hidden',
        },
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('lg')]: {
            width: theme.spacing(9),
        },
    },
    container: {
        backgroundColor: 'var(--brand-bg, #FFFBF7)',
        padding: '0px !important',
        paddingTop: '40px !important',
        paddingLeft: '60px !important',
        paddingRight: '60px !important',
        paddingBottom: '15px !important',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative',
        overflowX: 'hidden',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: props => (props.isDrawerOpen ? '280px' : '85px'),
        // Fill the full remaining width next to the (fixed) drawer. Using `%`
        // (not `vw`) keeps it inside the viewport when a vertical scrollbar is
        // present and reclaims the old ~5vw right-side gutter, which matters on
        // narrow 1280px / 11" screens where every pixel of content width counts.
        width: props => `calc(100% - ${props.isDrawerOpen ? '280px' : '85px'})`,

        // Trim the generous side padding on narrower desktops (≈11"–14" laptops,
        // up to 1440px) so page content (e.g. the 3-up cards on the Create page)
        // fits next to the sidebar without being clipped. Full padding returns on
        // wide monitors where the space is available.
        '@media (min-width:960px) and (max-width:1439.95px)': {
            paddingLeft: '45px !important',
            paddingRight: '28px !important',
        },

        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
            marginLeft: '0 !important',
            paddingLeft: '16px !important',
            paddingRight: '16px !important',
        },
        [theme.breakpoints.down('md')]: {
            paddingTop: '100px !important',
            paddingLeft: '24px !important',
            paddingRight: '24px !important',
            marginLeft: '0 !important',
            width: '100% !important',
        },
    },
    menuToggle:{
        [theme.breakpoints.down('md')]: {
            display:'none'
        },
    },
    profileButton: {
        top: 16,
        [theme.breakpoints.down('sm')]: {
            top: 6,
        },
    },
    logo: {
        height: 60,
        cursor: 'pointer',
    },
    drawerClose: {
        width: theme.spacing(9),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        [theme.breakpoints.up('lg')]: {
            width: theme.spacing(9),
        },
    },
}));


// - List
// - Accounts
// - Config
// - Subscriptions
// - Module UI Conf
// - Badge UI Conf
// - All Modules (Areas)
// - All Badges

const pathToLabelHeadMap = {
    // 'home': 'Overview',
    // 'password__change': 'Change Password',
    // 'ui_config': 'UI Configs',
    //
    // 'overview': 'Applications Overview',
    //
    // 'company__view': 'Organization Information',
    // 'company__update': 'Update Organization Information',
    //
    // 'application__list': 'Submitted Applications',
    // 'application__create': 'Create Application',

    'dq_pro__home': 'Home',
    'dq_pro__products': 'Your Products',
    'dq_pro__sales__resources': 'Sales Resources',
    'dq_pro__client__list': 'Client List',
    'dq_pro__assessment__list': 'Assessment List',
};


const Main = props => {
    const { children, history, location } = props;
    const [isDrawerOpen, setDrawerOpen] =  React.useState(
        JSON.parse(localStorage.getItem('isDrawerOpen')) || true
    );
    const classes = useStyles({ isDrawerOpen });
    const [labelHeading, setLabelHeading] = React.useState('');
    const { setAuthToken, setAuthUser, authUser } = useAuth();
    const { isDark: isDarkMode } = useColorMode();
    const { startTutorial, isActive, currentStep } = useTutorial();

    // Auto-open the drawer when the tutorial reaches a step whose target lives
    // inside a collapsed sub-menu (those elements are unmounted when the drawer
    // is closed, so the popover would never find them).
    const SIDEBAR_COLLAPSIBLE_TARGETS = [
        '#sidebar-products-link',
        '#sidebar-assessment-list-link',
        '#sidebar-classes-link',
        '#sidebar-opportunity-pipeline-link',
    ];
    useEffect(() => {
        if (!isActive || !currentStep) return;
        if (SIDEBAR_COLLAPSIBLE_TARGETS.includes(currentStep.target) && !isDrawerOpen) {
            setDrawerOpen(true);
            localStorage.setItem('isDrawerOpen', JSON.stringify(true));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, currentStep]);

    const [pathKey, setPathKey] = React.useState('dq_pro__home');

    const anchorRefUserMenu = React.useRef(null);
    const [openUserMenu, setOpenUserMenu] = React.useState(false);
    const [wsPickerOpen, setWsPickerOpen] = React.useState(false);
    const [wsSwitching, setWsSwitching] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1200);

    // Handle sidebar toggle and persist state
    const handleDrawerToggle = () => {
        setDrawerOpen((prev) => {
            const newState = !prev;
            localStorage.setItem('isDrawerOpen', JSON.stringify(newState));
            return newState;
        });
    };
    // Ensure `isDrawerOpen` is set correctly on refresh
    React.useEffect(() => {
        const storedState = localStorage.getItem('isDrawerOpen');
        if (storedState !== null) {
            setDrawerOpen(JSON.parse(storedState));
        }
    }, []);

    // The Class dashboard needs the class code (?section_code=). Remember the last one seen in this tab,
    // so a route that lost the query (a redirect, a link without it) goes back to the same class instead
    // of bouncing to the workspace home (QA 9 Oct, LA-CD-1). Only with no class at all does it leave.
    React.useEffect(() => {
        if (!location.pathname.startsWith('/dq_pro/class-dashboard')) return;
        const CLASS_KEY = 'dq_seal_cl_class_section_code';
        const params = new URLSearchParams(location.search);
        const code = params.get('section_code');
        if (code) {
            try { sessionStorage.setItem(CLASS_KEY, code); } catch (e) { /* storage unavailable: nothing to remember */ }
            return;
        }
        let remembered = null;
        try { remembered = sessionStorage.getItem(CLASS_KEY); } catch (e) { remembered = null; }
        if (remembered) {
            params.set('section_code', remembered);
            history.replace({pathname: location.pathname, search: `?${params.toString()}`});
        } else {
            history.push('/my_workspace');
        }
    }, [location.pathname, location.search, history]);


    // User Menu Handlers
    const handleUserMenuToggle = () => {
        setOpenUserMenu((prevOpen) => !prevOpen);
    };

    const handleUserMenuClose = (event) => {
        if (anchorRefUserMenu.current && anchorRefUserMenu.current.contains(event.target)) {
            return;
        }

        setOpenUserMenu(false);
    };

    const updateScreenSize = () => {
        setIsMobile(window.innerWidth <= 600);
    };

    const handleChangePassword = (event) => {
        handleUserMenuClose(event);
        history.push('/password/change');
    }

    /**
     * PW_PI_ST — Settings, in the Profile Icon menu.
     *
     * Takes the event and hands it to handleUserMenuClose, which reads
     * event.target to tell an outside click from a click on the avatar itself.
     * Calling it without one throws.
     */
    const handleOpenSettings = (event) => {
        handleUserMenuClose(event);
        history.push('/account/settings');
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenUserMenu(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevUserMenuOpen = React.useRef(openUserMenu);
    React.useEffect(() => {
        if (prevUserMenuOpen.current === true && openUserMenu === false) {
            anchorRefUserMenu.current.focus();
        }

        prevUserMenuOpen.current = openUserMenu;
    }, [openUserMenu]);

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.user_email);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.dqpro_v2_google_auth_redirect);
            // Reset the per-session tutorial dismissal so the next login starts fresh
            // (the ✕-close suppression is scoped to a single login session).
            localStorage.removeItem(TUTORIAL_SESSION_DISMISS_KEY);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    // ── Multi-org: workspace switcher (profile menu) ─────────────────────────
    const workspaceMemberships = authUser?.workspace_memberships || [];
    const isMultiWorkspace = workspaceMemberships.filter((m) => m?.is_active !== false).length > 1;

    // Resolve the role of the membership the user is *currently* in. A user can hold
    // two roles (peer + client) for the same workspace, so dq_insider_id alone is not
    // enough — match on is_peer + org_code too. Drives the "current" marker in the
    // picker and the no-op guard below.
    const activeMembership =
        workspaceMemberships.find(
            (m) => m.dq_insider_id === authUser?.dq_insider_id
                && (m.role === 'peer') === (authUser?.is_peer === true)
                && (m.org_code || null) === (authUser?.org_code || null),
        ) || workspaceMemberships.find((m) => m.dq_insider_id === authUser?.dq_insider_id);
    const currentRole = activeMembership?.role || (authUser?.is_peer ? 'peer' : null);

    const handleSwitchWorkspaceClick = (event) => {
        handleUserMenuClose(event);
        setWsPickerOpen(true);
    };

    const handleWorkspaceSelect = async (dq_insider_id, role) => {
        // Skip only when re-selecting the exact same workspace AND role the user is
        // already in. (A user can hold two roles for one workspace — e.g. peer and
        // client — so dq_insider_id alone is not enough to detect a no-op.)
        if (dq_insider_id === authUser?.dq_insider_id && (!role || role === currentRole)) {
            setWsPickerOpen(false);
            return;
        }
        try {
            setWsSwitching(true);
            const result = await switchWorkspaceService(dq_insider_id, role);
            if (result.data && result.data.user) {
                await setAuthToken(result.data.auth_token);
                await setAuthUser(result.data.user);
                if (result.data.refresh_token) {
                    localStorage.setItem(LOCAL_STORAGE_KEYS.refresh_token, JSON.stringify(result.data.refresh_token));
                }
                localStorage.setItem(LOCAL_STORAGE_KEYS.user_email, JSON.stringify(result.data.user.email));
                setWsPickerOpen(false);
                clearAllBrandingCaches();
                // Full reload so every workspace-scoped view re-fetches under the new session.
                window.location.assign('/my_workspace');
            }
        } catch (e) {
            // already toasted by invokeApi
        } finally {
            setWsSwitching(false);
        }
    };

    useEffect( ()=>{

        const path_parts = location.pathname.split('/');
        console.log('path_parts --> ', path_parts)
        if (path_parts.length > 1) {
            if (path_parts.length < 3) {
                const path_key = path_parts[1];
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            } else {
                const path_key = `${path_parts[1]}__${path_parts[2]}`;
                if (pathToLabelHeadMap[path_key]) {
                    setLabelHeading(pathToLabelHeadMap[path_key]);
                    setPathKey(path_key);
                }
            }
        }

    },[location]);

    return (
        <div className={classes.root}>
            <CssBaseline/>
            {/* AppBar for Mobile */}
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        aria-label="menu"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon/>
                    </IconButton>
                    {/*<Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>*/}
                    {/*    {labelHeading}*/}
                    {/*</Typography>*/}

                </Toolbar>
            </AppBar>

            {/* Drawer */}
            <Drawer
                variant={isMobile ? "temporary" : "permanent"}
                PaperProps={{
                    id: 'main-sidebar-drawer',
                    style: { background: 'var(--brand-surface, #ffffff)', color: 'var(--brand-text-muted, #A5A5A5)', boxShadow: 'none', borderRadius: 0, border: 'none', top: 0, left: 0, height: '100vh' }
                }}
                classes={{
                    paper: clsx(classes.drawerPaper, {
                        [classes.drawerClose]: !isDrawerOpen,
                    }),
                }}
                open={isDrawerOpen}
                onClose={handleDrawerToggle} // Only for mobile
                ModalProps={{
                    keepMounted: true, // Improve performance on mobile
                }}
            >
                <div style={{display: 'flex', flexDirection: 'column', height: '100vh'}}>
                    {/* Drawer header: toggle button + logo in one row */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: isDrawerOpen ? '0px 12px 0px 4px' : '10px 0 16px',
                        justifyContent: isDrawerOpen ? 'space-between' : 'center',
                        borderBottom: '1px solid var(--brand-border, #f5f5f5)',
                        minHeight: '76px',
                        flexShrink: 0,
                    }}>
                        <IconButton
                            style={{color: 'var(--brand-text, #1F2937)', flexShrink: 0}}
                            onClick={handleDrawerToggle}
                        >
                            {isDrawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
                        </IconButton>
                        {isDrawerOpen && (
                            <BrandingLogo height={60} />
                        )}
                    </div>
                    {location.pathname.startsWith('/dq_pro/partner-dashboard') ? (
                        <PartnerDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    ) : location.pathname.startsWith('/dq_pro/school-dashboard') ? (
                        <SchoolDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    ) : location.pathname.startsWith('/dq_pro/network-dashboard') ? (
                        <NetworkDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    ) : location.pathname.startsWith('/dq_pro/class-dashboard') ? (
                        <ClassDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    ) : (location.pathname.startsWith('/dq_pro/individual-dashboard')
                        // Individual learners (access 25) always get the personal
                        // dashboard menu — never the main-account menu (Billing,
                        // Peers…), which their inherited plan would otherwise show.
                        || authUser?.access_level === USER_ACCESS_LEVEL.INDIVIDUAL_ACCESS_DQ_INSIDER_PORTAL) ? (
                        <IndividualDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    ) : location.pathname.startsWith('/dq_pro/national-dashboard') ? (
                        <NationalDashboardList
                            isDrawerOpen={isDrawerOpen}
                        />
                    /*
                     * The client-side workspaces: a school (22) and a school
                     * network (21) share this menu component, which then picks
                     * SCHOOL_WORKSPACE_NAV or NETWORK_WORKSPACE_NAV from
                     * is_school_network.
                     *
                     * Level 21 is matched together with the flag, not on its own.
                     * 21 predates this work and is held by accounts that are not
                     * school networks; those must keep the menu they have today.
                     */
                    ) : isClientWorkspace(authUser) ? (
                        <PartialMainList
                            isDrawerOpen={isDrawerOpen}
                            logoutAction={handleLogout}
                        />
                    ) : authUser?.access_level === USER_ACCESS_LEVEL.TEACHER_ACCESS_DQ_INSIDER_PORTAL ? (
                        <TeacherMainList
                            isDrawerOpen={isDrawerOpen}
                            logoutAction={handleLogout}
                        />
                    ) : (
                        <MainList
                            path={pathKey}
                            isDrawerOpen={isDrawerOpen}
                            logoutAction={handleLogout}
                            changePasswordAction={handleChangePassword}
                        />
                    )}
                </div>
            </Drawer>
            <main className={classes.content}>
                {/* Profile icon — fixed top-right of content area */}
                <IconButton
                    id="user-profile-menu-button"
                    ref={anchorRefUserMenu}
                    onClick={handleUserMenuToggle}
                    className={classes.profileButton}
                    style={{
                        position: 'fixed',
                        right: 24,
                        zIndex: 1210, // above AppBar (zIndex.drawer+1 = 1201) so it's never hidden on mobile
                        border: `2px solid var(--brand-primary, #FF6900)`,
                        padding: 6,
                        backgroundColor: 'var(--brand-surface, #fff)',
                    }}
                >
                    <AccountCircle style={{color: 'var(--brand-primary, #FF6900)', fontSize: 28}}/>
                </IconButton>

                {/* User dropdown menu */}
                <Popper open={openUserMenu} anchorEl={anchorRefUserMenu.current} role={undefined} transition disablePortal style={{zIndex: 1400}}>
                    {({TransitionProps, placement}) => (
                        <Grow {...TransitionProps} style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}>
                            <Paper style={{
                                border: isDarkMode ? '1px solid #2D2D2D' : '1px solid #E5E7EB',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                borderRadius: 10,
                                minWidth: 200,
                                backgroundColor: isDarkMode ? '#1A1A1A' : '#ffffff',
                            }}>
                                <ClickAwayListener onClickAway={handleUserMenuClose}>
                                    <MenuList autoFocusItem={openUserMenu} id="profile-menu" onKeyDown={handleListKeyDown}>
                                        <MenuItem disabled style={{color: 'var(--brand-primary, #FF6900)', fontWeight: 700, fontSize: 14, opacity: 1}}>
                                            {authUser?.is_guest ? 'Guest User' : (authUser?.email || 'User')}
                                        </MenuItem>
                                        {/*
                                          * MenuList takes an array of children, not a Fragment — a
                                          * Fragment makes it lose track of them for keyboard focus
                                          * and logs a warning. So these are returned as an array
                                          * rather than wrapped in <>.
                                          *
                                          * PW_PI_ST — the sheet moves "Account settings" out of the
                                          * sidebar into this menu, reworded to "Settings". It points
                                          * at the same page it always did, so nothing is lost.
                                          *
                                          * The sheet gives Settings four tabs — Account, Security,
                                          * Billing and Payments, Advanced Settings (PW_PI_ST_A, _S,
                                          * _BP, _AS). The page already has its own tab bar, but with
                                          * eight tabs rather than four, so which existing tab folds
                                          * into which of the sheet's is still open. Billing therefore
                                          * remains a sidebar item for now.
                                          *
                                          * "Reset Password" is gone from this menu: sheet row 39 says
                                          * "Remove (can be found inside 'Settings')", and the Security
                                          * tab does exactly that. handleChangePassword is kept — the
                                          * forced temp-password flow above still calls it.
                                          */}
                                        {!authUser?.is_guest && [
                                            <Divider key="pi-divider" style={{margin: '4px 0', borderColor: isDarkMode ? '#2D2D2D' : undefined, backgroundColor: isDarkMode ? '#2D2D2D' : undefined}}/>,
                                            <MenuItem key="pi-settings" style={{color: 'var(--brand-primary, #FF6900)', fontSize: 14}} onClick={handleOpenSettings}>
                                                Settings
                                            </MenuItem>,
                                        ]}
                                        {isMultiWorkspace && !authUser?.is_guest && (
                                            <MenuItem style={{color: 'var(--brand-primary, #FF6900)', fontSize: 14}} onClick={handleSwitchWorkspaceClick}>
                                                Switch Workspace
                                            </MenuItem>
                                        )}
                                        {/*
                                          * Dark mode is no longer offered here. Sheet row 40:
                                          * "Dark Mode — Move: inside 'Advanced Settings' under
                                          * 'Settings'", and Advanced Settings now holds exactly
                                          * that toggle. The sidebar keeps its own toggle, so this
                                          * removal does not make dark mode harder to reach.
                                          */}
                                        <Divider style={{margin: '4px 0', borderColor: isDarkMode ? '#2D2D2D' : undefined, backgroundColor: isDarkMode ? '#2D2D2D' : undefined}}/>
                                        {/* PW_PI_SO — the sheet rewords "Log out" to "Sign out". */}
                                        <MenuItem style={{color: 'var(--brand-primary, #FF6900)', fontSize: 14}} onClick={handleLogout}>
                                            Sign out
                                        </MenuItem>
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>

                <OrgPickerDialog
                    open={wsPickerOpen}
                    orgs={workspaceMemberships}
                    currentId={authUser?.dq_insider_id}
                    currentRole={currentRole}
                    loading={wsSwitching}
                    onSelect={handleWorkspaceSelect}
                    onCancel={() => setWsPickerOpen(false)}
                />

                <Container maxWidth={false} className={classes.container}>
                    {children}
                    <footer className={classes.footer} style={{marginTop: 'auto', paddingTop: '30px'}}>
                        <Box sx={{pt: {xs: '3', sm: '4'}}}>
                            <Copyright/>
                        </Box>
                    </footer>
                </Container>
            </main>
        </div>
    );
}

export default withRouter(Main);